import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';
import {getLang} from "./libs/utility";

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(reactI18nextModule) // if not using I18nextProvider
  .init({
    debug: false,
    whitelist: ["en", "fr"],
    nonExplicitWhitelist: true,
    load: 'languageOnly',
    fallbackLng: ['en', 'fr'],
    lng: getLang(),
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
    escapeValue: false, // not needed for react!!
    },
  });

export default i18n;
